var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import Textfield from "@atlaskit/textfield";
import { Field } from "@atlassiansox/microscopekit";
import { ErrorMessage } from "@atlaskit/form";
import { parseInputNumber } from "../../../../utils";
export var NumberField = function (_a) {
    var value = _a.value, name = _a.name, label = _a.label, onChange = _a.onChange, _b = _a.isRequired, isRequired = _b === void 0 ? false : _b, validate = _a.validate, _c = _a.isDisabled, isDisabled = _c === void 0 ? false : _c;
    var handleChange = function (fieldProps) { return function (e) {
        var numericValue = parseInputNumber(e);
        fieldProps.onChange(numericValue);
        onChange(numericValue);
    }; };
    var valueAsText = value === undefined ? "" : value.toString();
    return (React.createElement(Field, { name: name, label: label, isRequired: isRequired, defaultValue: valueAsText, validate: validate }, function (_a) {
        var fieldProps = _a.fieldProps, error = _a.error;
        return (React.createElement(React.Fragment, null,
            React.createElement(Textfield, __assign({}, fieldProps, { onChange: handleChange(fieldProps), value: valueAsText, isDisabled: isDisabled })),
            error && React.createElement(ErrorMessage, null, error)));
    }));
};
